/* VETINESS Shopify Theme JS */

const moneyFormat = (cents) =>
  (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

function toggleNav() {
  const links = document.getElementById('navLinks');
  const btn = document.querySelector('.nav-toggle');
  const open = links.classList.toggle('open');
  btn.classList.toggle('open', open);
  btn.setAttribute('aria-expanded', open);
}

function toggleCart(open) {
  document.getElementById('cartDrawer').classList.toggle('open', open);
  document.getElementById('cartOverlay').classList.toggle('open', open);
  document.body.classList.toggle('cart-open', open);
  if (open) refreshCart();
}

async function refreshCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  renderCart(cart);
}

function renderCart(cart) {
  const box = document.getElementById('cartItems');
  const count = document.getElementById('cartCount');
  const total = document.getElementById('cartTotal');
  if (count) count.textContent = cart.item_count;
  if (total) total.textContent = moneyFormat(cart.total_price);
  if (!box) return;
  if (cart.items.length === 0) {
    box.innerHTML = '<p class="cart-empty">Dein Warenkorb ist leer.<br>🐾</p>';
    return;
  }
  box.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : ''}" alt="">
      <div>
        <div class="ci-title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="ci-variant">${item.variant_title}</div>` : ''}
        <div class="ci-price">${moneyFormat(item.final_line_price)}</div>
        <button class="ci-remove" onclick="updateLine('${item.key}', 0)">Entfernen</button>
      </div>
      <div class="ci-qty">
        <button onclick="updateLine('${item.key}', ${item.quantity - 1})" aria-label="Menge verringern">−</button>
        <span>${item.quantity}</span>
        <button onclick="updateLine('${item.key}', ${item.quantity + 1})" aria-label="Menge erhöhen">+</button>
      </div>
    </div>`).join('');
}

async function updateLine(key, qty) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  renderCart(await res.json());
}

async function addVariant(variantId, qty) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    showToast(err.description || 'Konnte nicht hinzugefügt werden');
    return false;
  }
  await refreshCart();
  toggleCart(true);
  return true;
}

function quickAdd(variantId) { addVariant(variantId, 1); }

function addToCart() {
  const btn = document.getElementById('addBtn');
  const qty = parseInt(document.getElementById('qtyInput').value, 10) || 1;
  addVariant(parseInt(btn.dataset.variantId, 10), qty);
}

function changeQty(delta) {
  const input = document.getElementById('qtyInput');
  input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
}

function fmtUnit(cents, ref) {
  return cents > 0 && ref ? moneyFormat(cents) + ' / ' + ref + ' · ' : '';
}

function selectVariant(btn) {
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const priceNow = document.getElementById('priceNow');
  const pricePer = document.getElementById('pricePer');
  const addBtn = document.getElementById('addBtn');
  priceNow.textContent = moneyFormat(parseInt(btn.dataset.cents, 10));
  pricePer.textContent = fmtUnit(parseInt(btn.dataset.unitCents, 10) || 0, btn.dataset.unitRef) + 'inkl. MwSt.';
  if (btn.dataset.image) setMainImg(btn.dataset.image, null);
  addBtn.dataset.variantId = btn.dataset.variantId;
  addBtn.disabled = btn.dataset.available !== 'true';
  const url = new URL(window.location);
  url.searchParams.set('variant', btn.dataset.variantId);
  history.replaceState({}, '', url);
}

function setMainImg(src, thumb) {
  document.getElementById('mainImg').src = src;
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

function openLightbox(src) {
  const lb = document.getElementById('lightbox');
  document.getElementById('lightboxImg').src = src;
  lb.classList.add('open');
}
function closeLightbox() {
  document.getElementById('lightbox').classList.remove('open');
}

function scrollToBuy() {
  const el = document.getElementById('produkt');
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

/* Robuster Anker-Sprung: macht das Ziel sofort sichtbar */
function scrollToSection(id, ev) {
  if (ev) ev.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  el.querySelectorAll('.reveal').forEach(r => r.classList.add('visible'));
  el.classList.add('visible');
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function showToast(msg) {
  let t = document.querySelector('.toast');
  if (!t) {
    t = document.createElement('div');
    t.className = 'toast';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2600);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.size-price[data-cents]').forEach(el => {
    el.textContent = moneyFormat(parseInt(el.dataset.cents, 10));
  });
  const pn = document.getElementById('priceNow');
  if (pn && pn.dataset.cents) pn.textContent = moneyFormat(parseInt(pn.dataset.cents, 10));
  const pp = document.getElementById('pricePer');
  if (pp && pp.dataset.unitCents !== undefined) {
    pp.textContent = fmtUnit(parseInt(pp.dataset.unitCents, 10) || 0, pp.dataset.unitRef) + 'inkl. MwSt.';
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { toggleCart(false); closeLightbox(); }
  });
});
